import React from 'react';
import classNames from 'classnames';
import { SectionSplitProps } from '../../utils/SectionProps';
import SectionHeader from './partials/SectionHeader';
import Image from '../elements/Image';
import * as proj from '../../Lokesh_Profile.json'
const propTypes = {
  ...SectionSplitProps.types
}

const defaultProps = {
  ...SectionSplitProps.defaults
}

const FeaturesSplit = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  invertMobile,
  invertDesktop,
  alignTop,
  imageFill,
  ...props
}) => {

  const outerClasses = classNames(
    'features-split section',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'features-split-inner section-inner',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );

  const splitClasses = classNames(
    'split-wrap',
    invertMobile && 'invert-mobile',
    invertDesktop && 'invert-desktop',
    alignTop && 'align-top'
  );

  

  return (
    <div className="container-sm">
      <div className={innerClasses}>
        <div class="row justify-content-center mb-5 pb-5">
          <div
            class="col-md-7 text-center heading-section fadeInUp reveal-from-bottom is-revealed"
            data-reveal-delay="200"
          >
            <span>PORTFOLIO</span>
            <h2 style={{ marginTop: "0px" }}>PROJECTS</h2>
          </div>
        </div>
        <br />
        <div className={splitClasses}>
          {proj.Projects && proj.Projects.length > 0 ? (
            proj.Projects.map((item) => (
              <div className="split-item">
                <div
                  className="split-item-content center-content-mobile reveal-from-left"
                  data-reveal-container=".split-item"
                >
                  <h3 className="mt-0 mb-12">{item.name}</h3>
                  <div className="text-xxs text-color-primary fw-600 tt-u mb-8">
                    {item.tech}
                  </div>
                  <p className="m-0">{item.desc}</p>
                  {item.URL != "" ? (
                    <a
                      href={item.URL}
                      style={{ marginTop: "40px", color: "cornflowerblue" }}
                    >
                      View Project
                    </a>
                  ) : (
                    <></>
                  )}
                </div>
                <div
                  className={classNames(
                    "split-item-image center-content-mobile reveal-from-bottom",
                    imageFill && "split-item-image-fill"
                  )}
                  data-reveal-container=".split-item"
                >
                  <Image
                    src={item.img}
                    alt="Features split 01"
                    width={528}
                    height={396}
                  />
                </div>
              </div>
            ))
          ) : (
            <></>
          )}
        </div>
      </div>
    </div>
  );
}

FeaturesSplit.propTypes = propTypes;
FeaturesSplit.defaultProps = defaultProps;

export default FeaturesSplit;